/**
 * Ouvir um áudio do Desk Cloud sem sair da lista (o play do cartão e a pré-visualização): um áudio só
 * de cada vez, que só quem abriu ouve. Tocar para a mesa é outra coisa (o "Usar na mesa").
 */
import { create } from 'zustand';
import { serverUrl } from '../serverUrl.js';
import type { DeskFile } from '../shared.js';

type ListenState = {
  /** o arquivo tocando (ou pausado no meio) */
  id: string | null;
  playing: boolean;
  /** a posição de 0 a 1 */
  progress: number;
  toggle: (file: DeskFile) => void;
  stop: () => void;
};

let audio: HTMLAudioElement | null = null;

export const useListen = create<ListenState>()((set, get) => ({
  id: null,
  playing: false,
  progress: 0,
  toggle(file) {
    if (get().id === file.id && audio) {
      if (audio.paused) void audio.play().catch(() => set({ playing: false }));
      else audio.pause();
      return;
    }
    get().stop();
    const next = new Audio(serverUrl(file.url));
    audio = next;
    next.onplay = () => set({ playing: true });
    next.onpause = () => set({ playing: false });
    next.onended = () => set({ playing: false, progress: 0 });
    next.ontimeupdate = () => set({ progress: next.duration ? next.currentTime / next.duration : 0 });
    set({ id: file.id, playing: true, progress: 0 });
    void next.play().catch(() => set({ playing: false }));
  },
  stop() {
    if (audio) {
      audio.pause();
      audio.removeAttribute('src');
      audio = null;
    }
    set({ id: null, playing: false, progress: 0 });
  },
}));
